<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <el-row class="conentRow">
        <el-col :span="24" class="scenicBtn">
          <el-button type="primary" plain @click="editFn()">
            <i class="iconfont icon-jiahao"></i>
            添加角色
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="roleTable"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="title" label="角色名称"></el-table-column>
        <el-table-column prop="description" label="角色描述"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <img
              v-if="scope.row.status==1"
              style="vertical-align: middle;"
              src="@/images/worke/dl.png"
              alt
            />
            <img
              v-if="scope.row.status==2"
              style="vertical-align: middle;"
              src="@/images/worke/dr.png"
              alt
            />
            <el-button type="text">
              <span v-if="scope.row.status==1">启用</span>
              <span v-if="scope.row.status==2">禁止</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="400">
          <template slot-scope="scope">
            <el-button class="editCol" type="text" @click="delFn(scope.row)">删除</el-button>
            <el-button type="text" @click="rightFn(scope.row)">权限设置</el-button>
            <el-button type="text" @click="editFn(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="rolePar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{rolePar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="rolePar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="editDialogVisible"
      :before-close="editHandleClose"
      width="518px"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="88px" :model="roleData">
        <el-form-item label="角色名称:">
          <span class="absPosiA">*</span>
          <el-input v-model="roleData.title" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述:">
          <el-input type="textarea" v-model="roleData.description" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="是否启用:">
          <el-radio-group v-model="roleData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁止</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button @click="roleClear">清空</el-button>
          <el-button class="btnL" @click="sureFn">{{titleType=='修改角色'?'确认修改':'确认添加'}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
    <!-- 权限设置开始 -->
    <el-dialog :close-on-click-modal="false"
      title="角色权限"
      :visible.sync="rightDialogVisible"
      :before-close="rightHandleClose"
      width="54%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <div class="rightSet">
        <div class="rightWorke">
          <div>
            <span>{{name}}</span>
            <span>该角色用户拥有指定权限</span>
          </div>
          <div class="itemWorke" v-for="(item,index) in limits" :key="index">
            <div v-if="item.son">
              <div>{{item.title}}</div>
              <el-switch v-model="item.c" active-color="#246DEB" inactive-color="#E5E5EA" @change="switchCh(item,$event)"></el-switch>
            </div>
            <div v-if="item.son">
                <el-checkbox  :label="v.id" v-model="v.c" v-for="v in item.son" :key="v.id" @change="CheckBox(item,$event)" >{{v.title}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="itemRight" style="margin-left:-50px">
        <!-- <el-button @click="clearBtns">清空</el-button> -->
        <el-button class="btnL" @click="Btns">确认添加</el-button>
      </div>
    </el-dialog>
    <!-- 权限设置结束 -->
    <!-- 审核提交弹框开始 -->
    <!-- <el-dialog :close-on-click-modal="false"
      class="passDialog"
      :visible.sync="passDialogVisible"
      :before-close="passHandleClose"
      width="21%"
      center
      top="35vh"
    >
      <div class="passImg">
        <img style="width:128px;height:128px;" :src="imgUrl" alt />
      </div>
      <div class="passSucc">提交失败</div>
    </el-dialog>-->
    <!-- 审核提交弹框结束 -->
  </div>
</template>

<script>
import {
  getJfyRuleListPost,
  addJfyRulePost,
  updateJfyRulePost,
  deleteJfyRulePost,
  getJfyAuthListPost,
  ruleAddJfyAuth
} from "@/request/set.js";
import { MessageBox,Message } from 'element-ui'
export default {
  data() {
    return {
      titleType: "", // 添加修改区别
      editDialogVisible: false, // 添加管理员弹框
      passDialogVisible: false, // 提交失败弹框
      rightDialogVisible: false, // 权限设置弹框
      // 列表传参
      rolePar: {
        token: "",
        page: 1,
        page_size: 10
      },
      // 添加角色绑定数据
      roleData: {
        title: "",
        status: "",
        description: ""
      },
      // 添加角色传参
      editRolePar: {
        token: "",
        title: "",
        status: "",
        description: ""
      },
      roleTable: [], // 列表数据
      total: 1,
      roleId: "", // 存储角色id
      imgXl: require("@/images/scenics/sj.png"),
      imgXlb: require("@/images/scenics/sjh.png"),
      imgUrl: require("@/images/scenics/sqp.png"),
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      tableData: [
      ],
      options: [
      ],
      value: "",
      radio: "",
      // 工作台选项
      checkedWorde: 1, // 工作台选中
      limits:[],
      rules:'',
      id:"",
      name:""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.rolePar = {
      token: this.Token,
      page: 1,
      page_size:10
    };
    this.getList(this.rolePar);
  },
  methods: {
    roleClear(){
      this.roleData={
        title: "",
        status: "",
        description: ""
      }
    },
    clearBtns(){
      this.limits.map(item=>{
        item.c = false
        if(item.son){
          item.son.map(itm=>{
            itm.c = false
          })
        }
      })
      this.$forceUpdate()
    },
    CheckBox(item,e){
      if(e){
        item.c = true
      }else{
        item.c = false
      }
      for(let i=0;i<item.son.length;i++){
          if(item.son[i].c==true){
             item.c = true
            this.$forceUpdate()
             return false
          }
      }
      this.$forceUpdate()
    },
    switchCh(item,e){
      if(e==false){
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = false
          })
        }
      }else{
        item.son.map(itm=>{
          itm.c = true
        })
      }
      this.$forceUpdate()
    },
    // 确认添加
    Btns(){
      var auth_id = ''
      this.limits.map(item=>{
        if(item.c==true){
          auth_id += item.id +',' 
        }
        if(item.son!=undefined){
          item.son.map(im=>{
            if(im.c==true){
              auth_id += im.id +',' 
            }
          })
        }
      })
      if (auth_id.length > 0) {
         auth_id = auth_id.substr(0, auth_id.length - 1);
      }
      if(auth_id==''){
        Message.error('请选择权限')
        return false
      }
      let data = {
        token:this.Token,
        id:this.id,
        auth_id:auth_id,
        name:this.name
      }
      ruleAddJfyAuth(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList(this.rolePar);
          this.rightDialogVisible = false;
          this.limits = []
          this.getList(this.rolePar);
          Message.success('授权成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 获取列表数据
    getList(data) {
      let upData = {
        token: this.Token
      };
      getJfyAuthListPost(upData).then(res => {
        this.limits = res.data.result
      });
      getJfyRuleListPost(data).then(res => {
        this.rolePar.page = res.data.result.current_page
        this.roleTable = res.data.result.data;
        this.total = res.data.result.total;
      });
    },

    // 点击权限设置
    rightFn(row) {
      this.id = row.id
      this.name = row.title
      this.rightDialogVisible = true;
      if(row.rules!=''){
        row.rules.split(',').map(item=>{
          this.limits.map(v=>{
            if(v.id==item){
              v.c = true
            }
            if(v.son!=undefined){
              v.son.map(itm=>{
                if(itm.id==item){
                  itm.c = true
                  v.c = true
                }
              })
            }
          })
        })
      }else{
        
      }
    },
    // 点击权限设置关闭X
    rightHandleClose() {
      this.rightDialogVisible = false;
    },
    // 点击确认保存
    sureFn() {
      if (this.roleId) {
        console.log("修改");
        this.editRolePar = {
          token: this.Token,
          id: this.roleId,
          title: this.roleData.title,
          status: this.roleData.status,
          description: this.roleData.description
        };

        updateJfyRulePost(this.editRolePar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
             let data  = {
              token: this.Token,
            };
            this.getList(data);
          } else {
            Message.error(res.data.msg);
          }
        });
      } else {
        // 添加角色传参
        this.editRolePar = {
          token: this.Token,
          title: this.roleData.title,
          status: this.roleData.status,
          description: this.roleData.description
        };
        addJfyRulePost(this.editRolePar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
            this.rolePar = {
              token: this.Token,
              page:1,
              page_size:10
            };
            this.total = 0
            this.getList(this.rolePar);
          } else {
            Message.error(res.data.msg);
          }
        });
      }
      this.passDialogVisible = false;
      // this.editDialogVisible = true;
    },
    // 提交失败
    passHandleClose() {
      this.passDialogVisible = false;
    },
    // 删除
    delFn(row) {
      let upData = {
        id: row.id,
        token: this.Token
      };
      MessageBox("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteJfyRulePost(upData).then(res => {
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              this.rolePar = {
                token: this.Token,
                page:1,
                page_size:10
              };
              this.total = 0
              this.getList(this.rolePar);
            }else{
              Message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 添加管理员
    editFn(row) {
      if (row) {
        // 修改
        this.roleId = row.id;
        this.titleType = "修改角色";
        //   // 添加角色绑定数据
        this.roleData = {
          title: row.title,
          status: row.status,
          description: row.description
        };
      } else {
        // 添加
        this.titleType = "添加角色 ";
        // 初始化数据
        this.roleData = {
          title: "",
          status: 1,
          description: ""
        };
      }
      this.editDialogVisible = true;
    },
    // 添加管理员弹框X
    editHandleClose() {
      this.editDialogVisible = false;
    },
    handleCurrentChange(val) {
      this.rolePar.page = val;
      this.getList(this.rolePar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
.itemRight {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 30px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}

.rightSet {
  .rightWorke {
    > div:nth-child(1) {
      margin-bottom: 7px;
      > span:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    .itemWorke {
      margin-bottom: 17px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #666666;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        padding: 20px;
        // height: 44px;
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #4ecb73;
          border-color: #4ecb73;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #666666;
        }
      }
    }
  }
}
.passDialog {
  // /deep/.el-dialog__header{
  //   height: 0;
  // }
  .passImg {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 58px;
    margin-bottom: 33px;
  }
  .passSucc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    /* identical to box height */
    color: #000000;
    margin-bottom: 30px;
  }
}
.editForm {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  /deep/.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 42px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }

  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    width: 500px;
    height: 40px;
    /deep/.el-select {
      width: 100%;
      height: 100%;
    }
  }
}

.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}

.editCol {
  color: #ff4d4f;
}
.conentBox {
  margin-top: 17px;
  height: 740px;
  .conentRow {
    margin-bottom: 20px;
  }
}
.scenicBtn {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  // margin-left: 42px;
  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-dialog{
  min-width: 400px;
}
.editForm /deep/ .el-textarea, .editForm  /deep/.el-textarea__inner{
  height: 12rem;
}
.el-dialog__title{
  color: #000 !important;
  font-family: OPPOSans !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
</style>